import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import Workspace from './Workspace';
import { createIamAPI } from './API';
import memoize from 'memoizee';
import env from '../misc/env';
var WorkspaceStore = /*#__PURE__*/function (_Store) {
  function WorkspaceStore() {
    var _this;
    _classCallCheck(this, WorkspaceStore);
    _this = _callSuper(this, WorkspaceStore, arguments);
    _this.workspaces = _this.collection({
      model: Workspace
    });
    _this.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: _this.rootStore.authStore.getToken
    });
    _this.fetchWorkspace = memoize(_this.fetchWorkspace.bind(_this), {
      promise: true,
      length: 2
    });
    return _this;
  }
  _inherits(WorkspaceStore, _Store);
  return _createClass(WorkspaceStore, [{
    key: "clearFetchCacheFor",
    value: function clearFetchCacheFor(workspaceId) {
      this.fetchWorkspace.delete(workspaceId);
      return this;
    }
  }, {
    key: "fetchWorkspace",
    value: function () {
      var _fetchWorkspace = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.api.workspaces.get(id, params).then(this.workspaces.set));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchWorkspace(_x, _x2) {
        return _fetchWorkspace.apply(this, arguments);
      }
      return fetchWorkspace;
    }()
  }, {
    key: "fetchByDomain",
    value: function () {
      var _fetchByDomain = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(domain) {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.api.domains.get(domain).then(function (domainRecord) {
                if (domainRecord) {
                  return _this2.workspaces.set(_objectSpread(_objectSpread({}, domainRecord.workspace), {}, {
                    domains: [domainRecord]
                  }));
                }
                return null;
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchByDomain(_x3) {
        return _fetchByDomain.apply(this, arguments);
      }
      return fetchByDomain;
    }()
  }, {
    key: "find",
    value: function () {
      var _find = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(query) {
        var _this3 = this;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.api.workspaces.find(query).then(function (r) {
                return _objectSpread(_objectSpread({}, r), {}, {
                  data: _this3.workspaces.set(r.data)
                });
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function find(_x4) {
        return _find.apply(this, arguments);
      }
      return find;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.api.workspaces.create(data).then(this.workspaces.set));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function create(_x5) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, data) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.api.workspaces.update(id, data).then(this.workspaces.set));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function update(_x6, _x7) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, params) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.api.workspaces.delete(id, params));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function _delete(_x8, _x9) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
  }, {
    key: "cloneWorkspace",
    value: function () {
      var _cloneWorkspace = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id, data) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.api.workspaces.cloneWorkspace(id, data).then(this.workspaces.set));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function cloneWorkspace(_x10, _x11) {
        return _cloneWorkspace.apply(this, arguments);
      }
      return cloneWorkspace;
    }()
  }, {
    key: "getArchivalStatus",
    value: function () {
      var _getArchivalStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id) {
        var workspace, status;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return this.api.workspaces.get(id);
            case 3:
              workspace = _context8.sent;
              return _context8.abrupt("return", workspace.archival_status);
            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](0);
              if (!(_context8.t0.response && _context8.t0.response.status === 404)) {
                _context8.next = 13;
                break;
              }
              status = _context8.t0.response.data.archive_status;
              if (status === 'ARCHIVED') {
                this.workspaces.remove(id);
              }
              return _context8.abrupt("return", status);
            case 13:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 7]]);
      }));
      function getArchivalStatus(_x12) {
        return _getArchivalStatus.apply(this, arguments);
      }
      return getArchivalStatus;
    }()
  }]);
}(Store);
export { WorkspaceStore as default };
//# sourceMappingURL=WorkspaceStore.js.map
